  <template>
    <div class="animated fadeIn">     
           
       <!--<b-breadcrumb><h4>My Collections</h4></b-breadcrumb>-->
 

<!--- Card Start -->
        <div v-if="style_list!=''">
        <div v-for="(style_collections, index) in style_list" class="col-md-4 " style="float: left;margin-bottom: 15px;margin-top: 10px; " >
          <b-card-group deck >
            
              <b-card class="design_card" header-tag="header" >
                <template v-slot:header>
                  <div class="col-md-12" style="padding-left: 0px;">

                <h6 class="mb-0">
                    <a class="" style="text-align: center;">{{style_collections.design_title}}</a>
                 
                      <!-- <i @click="openCollectionModal(collections.collection_id,collections.collection_title)" title='Edit Collection' class="fa fa-pencil icons font-1xl d-block pull-right pointer"></i> -->
                 
                </h6>      
                          
                  
                  </div>

                </template>
                <!-- v-if="collections.design_list.length >0" -->
                <b-card-text style='max-height:250px;overflow-y: scroll;' > 

                  <div v-for="(style_list, index) in style_collections.style_list
                    " class="col-md-12" style="float:left;padding:8px;background-color:rgb(245, 245, 245);margin-bottom:2px;">  
                    <router-link :to="'/design_details/' + style_list.style_id">

                      <div v-if="style_list.style_name!='' " style="width: 100%;float:left;">
                        <div  style="width: 20%;float: left">


                         <img  v-bind:src="style_list.style_image" id="img_uploaded" style="height:42px; width:42px;" />
                        </div>
                        <div style="width: 75%;float: right;" >
                          <div class="col-md-12 ">
                             <b>{{style_list.style_name}}</b> <br>{{style_list.style_code}}

                          </div>
                             <h1>{{style_list.design_image}}</h1>   
                          <div class="col-md-12" style="font-size: 12px;">
                            {{style_list.color}} &nbsp; / &nbsp;{{style_list.operational_status}}
                            
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </b-card-text>
                <template v-slot:footer>
                 <span class="mb-0"> {{style_collections.style_list.length}} Styles(s)
                  <b-col class='col-md-1' style="float:right">
                    <span @click="addStyleDetails(style_collections.design_id,index)"> 
                      <i title='Add New Style' class=" pointer fa fa-plus icons font-1xl d-block "></i>
                    </span>
                  </b-col>
                  </span>
                </template>

              </b-card>
              

          </b-card-group>
        </div>
      </div>
      <div v-if="style_list==''" style="top: 50%;
    position: absolute;
    bottom: 50;
    right: 50%;
    left: 45%;">
        <b-col sm="4" md="2" xl class="mb-3 mb-xl-0">
    <b-button title="Add New Design" @click="addNewDesign = true" variant="danger" aria-pressed="true" class="fa fa-plus-circle fa-5x pointer" style="width: 150px !important;">&nbsp; Create New Design</b-button>

  </b-col>
      </div>
        <!--- Card End -->

       



  <!-- Add New Design Model -->
  <b-modal title="Create New Design" v-model="addNewDesign" @ok="addNewDesign = false">
      <b-row>
    
      <b-col sm="12" class='col-md-12'>
        
        <!-- <b-form name="createdesignform" @submit.prevent="createdesignForm('createdesignform')" > -->
           <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-col sm="12">
              <div class="col-md-12">
                <label for="name">Design Title</label>
                <b-form-input type="text" id="design_title" name="design_title" v-model="design_title"   placeholder="Please Enter Design Title." v-validate="'required|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.design_title') }"></b-form-input>
                <b-input-group >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('design_title')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.design_title')" class="help text-danger">{{ errors.first('form-1.design_title') }}</span>
                      </b-input-group>
              </div><br> 

              <div class="col-md-12" v-if="user_type!='Buyer'">    
                  
                <label for="name">Select Buyer</label>

                    <b-form-select v-model="buyer_id" id="buyer_id" name="buyer_id" placeholder="Please Select Buyer." v-validate="'required'">
                        <option :value="selected">--Select--</option>
                        <option  :value="style_list.buyer_id" v-for="style_list in buyer_arr"  >{{ style_list.buyer_name }}</option>
                    </b-form-select> 
                    <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('buyer_id')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.buyer_id')" id="statustxt" class="help text-danger">{{ errors.first('form-1.buyer_id') }}
                        </code>
                        </b-input-group>
                
              </div>  <br/> 

              <div class="col-md-12">    
                  
                <label for="name">Select Sub Category</label>

                    <b-form-select v-model="sub_catid" id="sub_catid" name="sub_catid" placeholder="Please Enter Sub Category." @change="getUtilityTypeList(sub_catid); getPoTypeList(sub_catid);" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.sub_catid') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="style_list.sub_catid" v-for="style_list in sub_cat_arr"  >{{ style_list.sub_cattitle }}</option>
                    </b-form-select> 
                    <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('sub_catid')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.sub_catid')" id="statustxt" class="help text-danger">{{ errors.first('form-1.sub_catid') }}
                        </code>
                        </b-input-group>
                
              </div>  <br/>
              <div class="col-md-12">
                <label for="name">PO Type</label>
                <b-form-select v-model="po_id" id="po_id" name="po_id" placeholder="Please Select PO Type." v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.po_id') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="style_list.po_id" v-for="style_list in po_typearr" >{{ style_list.potype_title }}</option>
                </b-form-select> 
                <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('po_id')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.po_id')" id="statustxt" class="help text-danger">{{ errors.first('form-1.po_id') }}
                        </code>
                        </b-input-group>

                    <!-- <span v-show="errors.has('form-5.potype_title')" class="help text-danger">{{ errors.first('form-5.potype_title') }}</span> -->
              </div><br>


              <div class="col-md-12">
                <b-form-group >
                  <label for="name">Utility type</label>
                  <b-form-select v-model="utility_id" id="utility_id" name="utility_id" placeholder="Please Select Utility Type." v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.utility_id') }">
                          <option :value="selected"  >--Select--</option>
                          <option  :value="style_list.utility_id" v-for="style_list in utility_type_arr" v-validate="'required'">{{ style_list.utilitytype_title }}</option>
                  </b-form-select> 
                  <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('utility_id')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.utility_id')" id="statustxt" class="help text-danger">{{ errors.first('form-1.utility_id') }}
                        </code>
                        </b-input-group>
                </b-form-group>
              </div>
   
            </b-col>
            <div slot="footer"  style="margin-top:20px">
            
              <b-button type="submit" variant="primary" class="px-4 pull-right" >Create Design</b-button>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
  <!-- Add New Design Model Ends-->


  <!-- Add Sample Model -->
  <b-modal title="New Style" v-model="addNewStyle" @ok="addNewStyle = false">
 
    <b-form name="designform" @submit.prevent="AddDesign('designform')" >
      <div  class='row' >
        
          <b-col md="6" class="pull-left">
              <b-form-group>
                <label for="name">Style name</label>
                <b-form-input type="text" id="name" v-model="style_name" required></b-form-input>
              </b-form-group>
          </b-col>    

          <!-- <b-col md="6" class="pull-left">    
              <b-form-group>
                <label for="name">Style ID</label>
                <b-form-input type="text" id="no" v-model="style_id"  readonly disabled :value="style_id">style_id</b-form-input>
              </b-form-group>
          </b-col> -->

           <b-col md="6" class="pull-left">    
              <b-form-group>
                <label for="name">Style Code</label>
                <b-form-input type="text" id="no" v-model="style_code"  readonly disabled :value="style_code">style_code</b-form-input>
              </b-form-group>
          </b-col>

          <b-col md="6" class="pull-left">      
              <b-form-group >
                <label for="name">Sub category</label>
                  <b-form-group>
                  <b-form-input type="text" id="no" v-model="sub_cattitle"  readonly disabled ></b-form-input>
                </b-form-group>
                   
                                 
                </b-form-group>

          </b-col>    


          <b-col md="6" class="pull-left">      
              <b-form-group >
                <label for="name">Segment</label>
                <b-form-input type="text" id="no" v-model="collection_details.segment_title"  readonly disabled ></b-form-input>
              </b-form-group>
          </b-col> 

          <b-col md="6" class="pull-left">      
               <b-form-group >
                <label for="name">PO Type</label>
                <b-form-input type="text" id="no" v-model="potype_title"  readonly disabled ></b-form-input>
              </b-form-group>
          </b-col> 


          <b-col md="6" class="pull-left">      
              <b-form-group >
                <label for="name">Utility type</label>

                <b-form-input type="text" id="no" v-model="utilitytype_title"  readonly disabled ></b-form-input>
              </b-form-group>
          </b-col>    

          <b-col md="6" class="pull-left">      
              <b-form-group> 
                <label for="name">Color</label> 
                <b-form-input type="text" id="name" v-model="color" required></b-form-input>
              </b-form-group>
          </b-col>

          <b-col md="6" class="pull-left">      
              <b-form-group>
                <label for="name">Number Of Size Sets</label>
                 
                 <b-form-select 
                  :plain="true"
                  v-model="selected_sizeset"
                  :options="no_of_sizeset" required>
                </b-form-select>
              </b-form-group>
          </b-col>


          <b-col md="12" class="pull-left">      
              <b-form-group>
                <label for="name">Style description</label>
                <b-form-input type="text" id="name" v-model="style_description" required></b-form-input>
              </b-form-group>
          </b-col>

          <b-col md="12" class="pull-left">      
              <b-form-group>
                  <label for="name">Upload File</label>
                <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Upload Design File" accept="image/*" @change="AddDesign" required
                ></b-form-file>
                
              </b-form-group>
          </b-col>  


          <!-- <b-col md="12" class="pull-left">      
              <div class="profile-image-container" v-if="remoteUrl!=null"> 
                  <div class="img img-invalid" style="background-image: url(&quot;null&quot;); ">
                    <img v-bind:src="remoteUrl"  id="img" style="height:180px; width:350px;" v-if="remoteUrl!=''">  
                  </div>
                  <button @click="removeImage" v-if="remoteUrl!=''" style="margin-left: 40%">Remove image</button>
                  <div class="actions">
                    
                  </div>
                  <br><br>

                  
                </div>
          </b-col> -->
  

           
          <b-col md="12" class="pull-right text-right">   
            <b-button type="submit"  variant="primary"  class="px-4" >Submit Style</b-button>
          </b-col>

         
      </div>
      </b-form>
   
  </b-modal>
  <!-- Add Sample Model Ends-->

  
  <!--- Add Collection Button -->
  <div id="mybutton" v-if="style_list!=''">
    
   <b-col  sm="4" md="2" xl class="mb-3 mb-xl-0">
    <b-button title="Add New Design" @click="openaddNewDesign" variant="danger" aria-pressed="true" class="fa fa-plus-circle fa-5x pointer" >&nbsp; Create New Design</b-button>

  </b-col>

  </div>

  </div>





</template>


<style >

/*.modal-content { width: 330px !important;margin:auto !important; }  */
.modal-footer{display: none;}
.feedback {
  background-color : #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
 
.card-body {
    flex: 1 1 auto;
    padding: 1.25rem;
    padding-left: 1px;
    padding-right: 1px;
    padding-top: 0px;

} 

#btn_design{
    top: 136px;
    left: 115px;
    /* bottom: -3px; */
    position: absolute;
    width: 139px;
    height: 43px;
}

#element.style {
    top: 136px;
    left: 115px;
    /* bottom: -3px; */
    position: absolute;
    width: 130px;
    height: 43px;
} 
#title{
  float: right;
}
/*#img_uploaded{
  height:42; 
  width:42;
}*/
@media (min-width: 576px){
.card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
    height: 354px;
}}
.pointer {cursor: pointer;}
</style>
 <script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'

const axios = require('axios')


export default {
  name: 'Cards',
  data: function () {
    return {
      sampelAddModal: false,
      //addDesignModal: false,
      addNewDesign:false,
      addNewStyle: false,
      selectColorModal:false,
      updateCollection:false,
      show: true,
      isCollapsed: true,
      style_list:[],
     // category_list:[],
      collection_title:'',
      Design_Name:'',
      Design_Id:'',
      url_path:'',
      collection_category:'',
      collection_subcategory:'',
      subcatlist:[],
      collection_Id_txt:'',
      collection_id_edit:0,
      collection_title_edit:'',
       categoryoptions: [
          { value: '1', text: 'Men' },
          { value: '2', text: 'Women' },
          { value: '3', text: 'Kids' },
          
        ],
        subcategoryoptions: [
          { value: '1', text: 'Accessories' },
          { value: '2', text: 'bottom Wear' },
        ],

        no_of_units_in_pack:[
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' }
        ],
        // utility_type:[
        //   { value: 'Core', text: 'Core' },
        //   { value: 'Fashion', text: 'Fashion' },
        //   { value: 'Essential', text: 'Essential' }
        // ],
        
        no_of_sizeset:[
        { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' }
        ],
        segment_id:[
        { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' }
        ],

        color_family:[],
        panton_color:[],
        

        panton_type:[
          { value: 'TCX', text: 'TCX' },
          { value: 'TPX', text: 'TPX' }
          
        ],
        //new added code
        //new added code
        remoteUrl:'',
        image:'',
        

      collection_id: 0,
      design_categoty_id: 0,
      style_name:'',
      style_description: '',
      segment_id: 0,
      design_subcategoty_id: 0, 
      po_typearr: [],
      sub_cat_arr:[],
      buyer_arr: [],
      utility_type_arr: [],
     //no_of_units_in_pack: 0,
      no_of_colors: 0,
      //no_of_sizeset: 0,
      created_by: '',
      upload_image: '',
      style_image:'',
      selectedPO_type: null,
      selectedpack: null, 
      selectedutility_type: null,
      selected_sub_category: null,
      color: '',
      createPO_type:null,
      design_title: '',
      sub_category:'',
      pantonColorSel:'',
      generated_design_id:'',
      style_id: '',
      style_code: '',
      selected_sizeset: null,
      selected_segment: 1,
      file:'',
      temp_img:'',
      selected:'',
      sub_catid:0,
      buyer_id: 0,
      sub_cattitle: '',
      sub_cat:[],
      po_id: '',
      potype_title: '',
      segment_title: '',
      utility_id: 0,
      utilitytype_title: '',
      collection_details: [],
      selected_collectionid: 0,
      selected_brandid: 0,
      collection_subcatid: 0,
      collection_po_id: 0,
      collection_segment_id: 0,
      user_type: '',
      user: 0,
      selected_buyer_id: 0,

        //new end


      
    }
  },
  created: function() {  
    
      var userData = localStorage.getItem('userData');
      if (userData) {
         var userInfo = JSON.parse(userData)
         this.user_type = userInfo[0].user_type;
         this.getbuyerlist();
         this.getcollectiondetails();
         this.getStyleList(); 
         this.getSubCategoryList();

         this.vendor_id = userInfo[0].vendor_id; 
         this.selected_collectionid = this.$route.params.id 
      }       


   
  },

  methods: {   

    uploadImage(imgname,imgtype){

      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      let file = event.target.files[0];
      data.append('file', file)
      data.append('user_id',userInfo[0].user_id)
      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }
      document.getElementById("overlay").style.display = "block";
      if(file.type=='image/jpeg' || file.type=='image/png'){

      axios.post(`${CONSTANTS.API_URL}/uploadfiles`,data, config)
       .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.remoteUrl = response.data.url;
      }).catch((err) =>{
          return new Error(err.message);
        })
    }
    else{
      // alert("Please Select JPG or PNG Format Image Only");
      this.$fire({
             text:"Please Select JPG or PNG Format Image Only.",
             type: "warning",
             timer: 30000
                        })
      this.remoteUrl= '';
      this.file='';
      this.uploadImage();
     // imgname = '';

    }
    },

    removeImage: function (e) {
      this.remoteUrl = '';
    },
  //Code for Image Ends 

  setSelectedColor : function(){

  },

    /****** Function to Get Collection Details ********/
    getcollectiondetails: function(value) {
      this.isBusy = true;  
      const Obj={
        collection_id: this.$route.params.id
      }    
      axios.post(`${CONSTANTS.API_URL}/getcollectiondetails`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.collection_details  = this.result.returnvalue[0];
          this.collection_segment_id = this.collection_details.segment_id;
          this.selected_brandid = this.collection_details.brand_id;
          this.totalRows = this.result.returnvalue.length;
          this.isBusy = !this.isBusy;
          this.getPoTypeList(this.collection_subcatid);
          this.getUtilityTypeList(this.collection_subcatid);
          
        }else {
         this.collection_details =[];
         this.totalRows=0;
           this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },



  /******Function To Get Utility Type List********/
      getUtilityTypeList: function(value) {
      this.isBusy = true;  
      const Obj={
        subcat_id: value
      }   
      axios.post(`${CONSTANTS.API_URL}/getUtilityTypeList`,Obj)
      .then(response => {
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.utility_type_arr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          this.isBusy = !this.isBusy;
          
        }else {
         this.utility_type_arr =[];
         this.totalRows=0;
           this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

  /******Function To Get Utility Type List Ends********/


  /******Function To Get PO Type List********/
      getPoTypeList: function(value) {
      this.isBusy = true;     
       const Obj={
        subcat_id: value
       }
      axios.post(`${CONSTANTS.API_URL}/getPoTypeList`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.po_typearr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          this.isBusy = !this.isBusy;
          
        }else {
         this.po_typearr =[];
         this.totalRows=0;
           this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

  /******Function To Get PO Type List Ends********/

      /******Function To Get Buyer List********/
      getbuyerlist: function(value) {
        this.isBusy = true; 
        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
       
        if(userInfo[0].user_type=='Brand_Designer'){
          
        // this.user= userInfo[0].brand_manager
        this.user= userInfo[0].user_id
        } 
        else{
         this.user= userInfo[0].user_id
        } 
        const Obj={
        brand_manager: this.user
       }
      axios.post(`${CONSTANTS.API_URL}/getbuyerlistagainstbrandmanager`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.buyer_arr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          this.isBusy = !this.isBusy;
          
        }else {
         this.buyer_arr =[];
         this.totalRows=0;
           this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

    /******Function To Get Sub Category List********/
      getSubCategoryList: function(value) {    
       
      axios.post(`${CONSTANTS.API_URL}/getSubCategoryList`,{})
      .then(response => {
        //document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.sub_cat_arr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          
          
        }else {
         this.sub_cat_arr =[];
         this.totalRows=0;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

    /****** Function to Get ColectionList ********/
    getStyleList: function () {
      document.getElementById("overlay").style.display = "block";
        this.isBusy = true;
      var userData = localStorage.getItem('userData');
      if (userData) {
           var userInfo = JSON.parse(userData)
         const Obj={
          //user_id: userInfo[0].user_id,
          collection_id: this.$route.params.id,
          user_type: userInfo[0].user_type,
          user_id: userInfo[0].user_id,
          buyer_id: userInfo[0].user_id,
          // po_id: this.po_id,
          // utility_id: this.utility_id,
         }   

        axios.post(`${CONSTANTS.API_URL}/getStyleDesignlist`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          // JSON responses are automatically parsed.
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {

            this.style_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;

            this.isBusy = !this.isBusy;
            
          }else {
           this.style_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


      }       

       


    },
     /****** Function to Get Category List ********/
    // Categorylist: function () {

    //     this.isBusy = true;
    //     var userdata = localStorage.getItem('userData')
    //     var userInfo = JSON.parse(userdata);

       
    //     axios.post(`${CONSTANTS.API_URL}/getCategoryList`,{})
    //     .then(response => {
    //       document.getElementById("overlay").style.display = "none";
    //       this.result = response.data
    //       if (this.result.returnmsg === 'Successful') {

    //         this.category_list  = this.result.returnvalue;
    //         this.totalRows = this.result.returnvalue.length;

            
    //         this.isBusy = !this.isBusy;
            
    //       }else {
    //        this.category_list =[];
    //        this.totalRows=0;
    //          this.isBusy = !this.isBusy;
    //       }


    //     })
    //     .catch(e => {
    //       this.errors.push(e)
    //     })


    // },

    openaddNewDesign:function(){
      this.design_title='';
      this.sub_catid='';
      this.buyer_id='';
      this.po_id='';
      this.utility_id='';
      this.addNewDesign = !this.addNewDesign;
    },
validateForm(scope) {
    
      this.$validator.validateAll(scope).then(result => {
        if (result) {         
          this.createdesignForm(scope);
        }
      });
    },
     /****** Function to Add Collection ********/
    createdesignForm(scope) {
       document.getElementById("overlay").style.display = "block";
       var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata);
       if(this.user_type=='Buyer'){
        this.buyer_id=userInfo[0].user_id;
        this.selected_buyer_id =this.buyer_id;
       }
      
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const designObj = {
            collection_id: this.$route.params.id,
            design_title: this.design_title,
            brand_id: this.selected_brandid,
            sub_catid: this.sub_catid,
            buyer_id: this.buyer_id,
            created_by:userInfo[0].email_id,
            po_id: this.po_id,
            utility_id: this.utility_id,
            designer_id: userInfo[0].user_id
          }

          if (this.design_title !== '' ) 
          {
            axios.post(`${CONSTANTS.API_URL}/addnewdesign`,designObj)
            .then(response => {
              document.getElementById("overlay").style.display = "none";
                if(response.data.returnmsg == 'Successful') {

                    // alert("New Design Added Successfully.");
                      this.$fire({
                       text:"New Design Added Successfully.",
                       type: "success",
                       timer: 30000
                        })
                    
                    this.addNewDesign = !this.addNewDesign;
                    this.getStyleList();
                    this.getcollectiondetails();
                    
                } else {
                  if (response.data.returnmsg === 'unsuccessful') {
                    // alert(response.data.returnvalue);
                    this.$fire({
                       text:response.data.returnvalue,
                       type: "error",
                       timer: 30000
                        })
                    this.showAlert=true
                    
                  }
                }
              })
          }
        }
      })
    },
     addStyleDetails(design_id, index) {
       if(this.style_list[index].style_list[0]=='' || this.style_list[index].style_list[0]== undefined ){
        this.style_name='';
        this.style_id='';
        this.style_code='';
        this.sub_catid=this.style_list[index].sub_catid;
        this.buyer_id=this.style_list[index].buyer_id;        
        this.sub_cattitle= this.style_list[index].sub_cattitle;
        this.selected_segment='';
        this.segment_title='';
        this.po_id=this.style_list[index].po_id;
        this.potype_title=this.style_list[index].potype_title;
        this.utility_id=this.style_list[index].utility_id;
        this.utilitytype_title=this.style_list[index].utilitytype_title;
        this.color='';
        this.selected_sizeset='';
        this.style_description='';
        this.addNewStyle =true;
        this.generated_design_id=design_id;
        
       }  
       else{
       this.style_name='';
        this.style_id=this.style_list[index].style_list[0].style_id;
        this.style_code=this.style_list[index].style_list[0].style_code
        this.sub_catid=this.style_list[index].style_list[0].sub_catid;
        this.buyer_id=this.style_list[index].style_list[0].buyer_id;
        this.sub_cattitle=this.style_list[index].style_list[0].sub_cattitle;
        this.selected_segment=this.style_list[index].style_list[0].selected_segment;
        this.segment_title=this.style_list[index].style_list[0].segment_title;
        this.po_id=this.style_list[index].style_list[0].po_id;
        this.potype_title=this.style_list[index].style_list[0].potype_title;
        this.utility_id=this.style_list[index].style_list[0].utility_id;
        this.utilitytype_title=this.style_list[index].style_list[0].utilitytype_title;
        this.color='';
        this.selected_sizeset='';
        this.style_description=this.style_list[index].style_list[0].style_description;
        this.addNewStyle =true;
        this.generated_design_id=design_id;
        this.addNewStyle =true;
        this.generated_design_id=design_id;
       }
       

     },


      /****** Function to Add Design ********/
      AddDesign (scope) {
        document.getElementById("overlay").style.display = "block";

        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata);
        
         var user_id = userInfo[0].user_id;

      let data = new FormData();
      let file = event.target.files[0];
      data.append('file', file)
      data.append('style_name',this.style_name)
      data.append('style_code','')
      data.append('design_id',this.generated_design_id)
      data.append('user_id',user_id)
      data.append('brand_id',this.selected_brandid)
      data.append('style_description',this.style_description)
      data.append('sub_catid',this.sub_catid)
      data.append('segment_id',this.collection_segment_id)
      data.append('user_type',userInfo[0].user_type)
      data.append('po_id',this.po_id)
      data.append('utility_id',this.utility_id)
      data.append('color',this.color)
      data.append('no_of_sizeset',this.selected_sizeset)
      data.append('created_by',userInfo[0].email_id)

      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }
      

      if (this.style_name !== '') {
      axios.post(`${CONSTANTS.API_URL}/addnewstyles`,data, config)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
      if(response.data.returnmsg == 'Successful') {
          this.style_image=response.data.url;
          // alert("New Style Added Successfully.");
             this.$fire({
                 text:"New Style Added Successfully.",
                 type: "success",
                 timer: 30000
                        })
          this.addNewStyle = !this.addNewStyle;
          this.getStyleList();
      } else {
        if (response.data.returnmsg === 'unsuccessful') {
          // alert(response.data.returnvalue);
            this.$fire({
                 text:response.data.returnvalue,
                 type: "error",
                 timer: 30000
                        })
          this.showAlert=true
          
        }
      }
      })
      }
      }


  }


}
</script>




